<style scoped>
</style>

<template>
    <div>
        <factory-order-list ref="orderList" :height="this.$tools.mainHeight() - 131" :isRoot="true" rights="'b,c,d,e,i,k,m'" :canAdd="true"></factory-order-list>
    </div>
</template>

<script>
import FactoryOrderList from "./Factory-order-list.vue";

export default {
    components: { FactoryOrderList }
};
</script>